module.exports = __webpack_public_path__ + "static/media/iconfinder_upload_folder_43552.13518972.png";